import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import routes from 'app/routes';
import { useContext } from 'components/Managers/Dashboard/Context';
import useApiData from 'components/Managers/Dashboard/Hooks/useApiData';
import StatisticButton from './StatisticButton';
import StatisticModal from './StatisticModal';

export default function CoveredStatistic({ value }) {
  const [showModal, setShowModal] = useState(false);
  const route = routes.api.managers.dashboard.policy_plans;
  const { state: { filters } } = useContext();
  const { data: policyPlans, loading: policyPlansLoading } = useApiData(showModal && route, filters);

  const columns = [
    {
      name: 'Plan Name',
      selector: (row) => row.title,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Covered Members',
      selector: (row) => row.covered,
      sortable: true,
    },
  ];

  return (
    <Col md="4" className="mb-2 mb-md-0">
      <StatisticButton
        label="Covered"
        value={value}
        onClick={() => setShowModal(true)}
        className="bg-primary-50"
      />

      <StatisticModal
        show={showModal}
        title="Covered"
        columns={columns}
        data={policyPlansLoading ? null : policyPlans}
        defaultSortFieldId={1}
        onCloseClick={() => setShowModal(false)}
      />
    </Col>
  );
}

CoveredStatistic.propTypes = {
  value: PropTypes.number,
};

CoveredStatistic.defaultProps = {
  value: null,
};
